
import React from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const InterfacesAssessment = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="bg-blue-700 p-8 md:p-12 text-white">
              <h2 className="text-2xl md:text-3xl font-bold mb-6">Ist Ihre Systemlandschaft optimal vernetzt?</h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold mb-2">Typische Herausforderungen:</h3>
                  <ul className="space-y-2 text-blue-100">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-2 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                      </svg>
                      <span>Manuelle Übertragung von Daten zwischen Systemen</span>
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-2 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                      </svg>
                      <span>Inkonsistente Daten zwischen verschiedenen Anwendungen</span>
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-2 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                      </svg>
                      <span>Zeitverzögerungen bei wichtigen Geschäftsprozessen</span>
                    </li>
                    <li className="flex items-center">
                      <svg className="w-5 h-5 mr-2 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                      </svg>
                      <span>Komplexität bei der Integration neuer Systeme</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold mb-2">Unsere Analyse:</h3>
                  <p className="text-blue-100">
                    In einem kostenlosen Erstgespräch analysieren wir Ihre aktuelle Systemlandschaft und identifizieren Optimierungspotenziale für eine bessere Integration.
                  </p>
                </div>
              </div>
            </div>

            <div className="p-8 md:p-12">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Ihre Vorteile durch eine professionelle Schnittstellenlösung</h3>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start">
                  <div className="bg-green-100 p-1 rounded-full mr-3 flex-shrink-0 mt-1">
                    <svg className="h-4 w-4 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <span className="text-gray-700">
                    <strong>Gesteigerte Effizienz:</strong> Automatisierung von Datenaustauschprozessen spart Zeit und reduziert Fehler
                  </span>
                </li>
                <li className="flex items-start">
                  <div className="bg-green-100 p-1 rounded-full mr-3 flex-shrink-0 mt-1">
                    <svg className="h-4 w-4 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <span className="text-gray-700">
                    <strong>Datenhoheit:</strong> Konsistente Daten in allen Systemen sorgen für eine einheitliche Datenbasis
                  </span>
                </li>
                <li className="flex items-start">
                  <div className="bg-green-100 p-1 rounded-full mr-3 flex-shrink-0 mt-1">
                    <svg className="h-4 w-4 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <span className="text-gray-700">
                    <strong>Flexibilität:</strong> Schnellere Anpassung an neue Anforderungen und einfache Integration neuer Systeme
                  </span>
                </li>
                <li className="flex items-start">
                  <div className="bg-green-100 p-1 rounded-full mr-3 flex-shrink-0 mt-1">
                    <svg className="h-4 w-4 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <span className="text-gray-700">
                    <strong>Skalierbarkeit:</strong> Lösungen wachsen mit Ihren Anforderungen und Ihrem Unternehmen
                  </span>
                </li>
              </ul>
              <Button asChild size="lg" className="w-full bg-blue-700 hover:bg-blue-800">
                <Link to="/about">Kostenlose Beratung anfragen</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InterfacesAssessment;
